import { render, staticRenderFns } from "./politica_privacidad.vue?vue&type=template&id=e9d82034&"
import script from "./politica_privacidad.vue?vue&type=script&lang=js&"
export * from "./politica_privacidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports